export default {
  loading: false,
  data: null,
}